import {format} from 'date-fns';
import {includes} from 'lodash';
import {GetContractsQueryParams} from '../../../global/services/contracts';
import {DATETIME_ISO_FORMAT} from '../../../shared/constants/date-formats';
import {CriteriaTypeMap, Filter} from '../types';
import {isFilterStatus} from './is-filter-status.helper';

function isEmptyValue(prop: Filter): prop is Filter & {value: null | undefined | ''} {
  return prop.value === null || prop.value === undefined || prop.value === '';
}

function isStatus(prop: Filter): prop is {key: 'status'; value: CriteriaTypeMap['status']} {
  return prop.key === 'status' && isFilterStatus(prop.value);
}

function isDate(prop: Filter): prop is {key: 'startDate' | 'dueDate'; value: Date} {
  return includes(['startDate', 'dueDate'], prop.key) && prop.value instanceof Date;
}

export function prepareFilterParam(prop: Filter): GetContractsQueryParams {
  if (isEmptyValue(prop)) return {};
  if (isStatus(prop)) return {[prop.key]: prop.value};
  if (isDate(prop)) return {[prop.key]: format(prop.value, DATETIME_ISO_FORMAT)};
  return {[prop.key]: prop.value};
}
